import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { ICliente } from '../models/cliente';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClienteService {
  private apiUrl: string ='';
  constructor(private http: HttpClient) {
    this.apiUrl = environment.sUrlNomina + 'ClientesHM';
  }

  getListadoClientes(): Observable<ICliente[]> {
    return this.http
      .get<ICliente[]>(this.apiUrl)
      .pipe(retry(1), catchError(this.handleError));
  }

  public editClienteCompleto(data: ICliente ):Observable<any>{
    const headers = { 'content-type': 'application/json'}
    const body = JSON.stringify(data);
    return this.http.put<any>(this.apiUrl + '/editClienteCompleto/',body,{'headers':headers});
   }

   public saveCliente(data: ICliente ):Observable<any>{
    const headers = { 'content-type': 'application/json'}
    const body = JSON.stringify(data);
    return this.http.post<any>(this.apiUrl + '/saveCliente/',body,{'headers':headers});
   }


  handleError(error:any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
        return errorMessage;
    });
  }
}
